import moment from 'moment-timezone';
import {
  OrderTextCell,
  PhysicianCell,
  PrintCell,
  SignatureCell,
  OrderTypeCell,
  OrderDateCell,
  OrderCreationCell,
  CreatedByCell,
  NoteCountCellRenderer,
} from './CellRenderer';

import { physicianLastNameValueGetter } from './valueGetters';

const dateColumnFilterParams = {
  suppressAndOrCondition: true,
  // parseZone: compare wall-clock day from shifted string (no TZ conversion).
  comparator: (filterDate: Date, cellValue: string) => {
    if (!cellValue) {
      return -1;
    }
    const cellDay = moment.parseZone(cellValue).format('YYYY-MM-DD');
    const y = filterDate.getFullYear();
    const m = `${filterDate.getMonth() + 1}`.padStart(2, '0');
    const d = `${filterDate.getDate()}`.padStart(2, '0');
    const filterDay = `${y}-${m}-${d}`;
    if (cellDay === filterDay) {
      return 0;
    }
    return cellDay < filterDay ? -1 : 1;
  },
};

const orderType = {
  headerName: 'Type of Order',
  field: 'ordertypename',
  cellClass: 'no-border',
  width: 150,
  suppressSizeToFit: true,
  cellRendererFramework: OrderTypeCell,
  sortable: true,
};

const physicianDef = {
  headerName: 'Physician',
  field: 'frequency',
  cellClass: 'no-border',
  width: 175,
  cellRendererFramework: PhysicianCell,
  sortable: true,
  valueGetter: physicianLastNameValueGetter,
  filter: false,
};
const createdBy = {
  headerName: 'Created By',
  field: 'personname',
  cellClass: 'no-border',
  width: 175,
  cellRendererFramework: CreatedByCell,
  sortable: true,
};
const orderCreation = {
  headerName: 'Order Creation',
  field: 'noteddatetime',
  cellClass: 'no-border',
  width: 150,
  sortable: true,
  sort: 'asc',
  cellRendererFramework: OrderCreationCell,
  filter: 'agDateColumnFilter',
  filterParams: dateColumnFilterParams,
};
const createdOn = {
  headerName: 'Order Date',
  field: 'communicationdatetimeshifted',
  cellClass: 'no-border',
  width: 150,
  sortable: true,
  cellRendererFramework: OrderDateCell,
  filter: 'agDateColumnFilter',
  filterParams: dateColumnFilterParams,
};

const orderText = {
  headerName: '',
  field: 'text',
  cellClass: 'no-border',
  cellRendererFramework: OrderTextCell,
  width: 40,
  suppressSizeToFit: true,
  sortable: true,
};

const orderSignature = {
  headerName: '',
  field: 'signature',
  cellClass: 'no-border',
  suppressMenu: true,
  cellRendererFramework: SignatureCell,
  width: 40,
  suppressSizeToFit: true,
  sortable: true,
  valueGetter: ({ data }: { data: any }) => !!data?.signaturedatetime,
};
const printOrder = {
  headerName: '',
  field: 'print',
  cellClass: 'no-border',
  suppressMenu: true,
  cellRendererFramework: PrintCell,
  width: 40,
  suppressSizeToFit: true,
};

const noteCount = {
  headerName: '',
  field: 'noteCount',
  cellClass: 'no-border',
  suppressMenu: true,
  cellRendererFramework: NoteCountCellRenderer,
  width: 40,
  suppressSizeToFit: true,
  sortable: false,
  filter: false,
};

export const smallWidgetCPColumnDefs = [orderType];

export const expandedWidgetCPColumnDefs = [...smallWidgetCPColumnDefs];

export const smallWidgetPatientColumnDefs = [
  noteCount,
  orderType,
  physicianDef,
  orderCreation,
  createdOn,
];

export const expandedWidgetPatientColumnDefs = [
  ...smallWidgetPatientColumnDefs,
  createdBy,
  orderSignature,
  orderText,
  printOrder,
];
